import React from 'react';
import InnerComponent from '@Components/NotFound';

const NotFound = () => (
    <div>
        <InnerComponent />
    </div>
);
export default NotFound;
